import {AlpineComponent} from 'alpinejs';

type GlossaryData = {
  active: string,
  term: string,
  paginationLetterClick?(parameter: string): void,
}

export default (): AlpineComponent<GlossaryData> => ({
  active: 'all',
  term: '',
  init() {
    const getTermKey = () => {
      if (window.location.pathname.includes('/at/') || window.location.pathname.includes('/de/')) {
        return 'begriff';
      } else if (
        window.location.pathname.includes('/cz/') ||
        window.location.pathname.includes('/hr/') ||
        window.location.pathname.includes('/pl/') ||
        window.location.pathname.includes('/sk/')
      ) {
        return 'termin';
      } else if (window.location.pathname.includes('/hu/')) {
        return 'kifejezes';
      } else if (window.location.pathname.includes('/si/')) {
        return 'izraz';
      }
      return 'term';
    };

    const termKey = getTermKey();
    const regex = new RegExp(`/${termKey}/([^/]+)/`);
    const path = window.location.pathname;
    const match = path.match(regex);
    const term = match ? match[1] : '';
    this.term = term;
    if (term) {
      setTimeout(() => {
        const termElement = document.getElementById(term);
        if (termElement) {
          termElement.scrollIntoView({behavior: 'smooth', block: 'center', inline: 'nearest'});
        }
      }, 5);
    } else if (window.location.hash) {
      this.active = window.location.hash.replace('#', '');
      const glossaryContainerElement = document.getElementById('glossary-container');
      if (glossaryContainerElement) {
        glossaryContainerElement.scrollIntoView({behavior: 'smooth', block: 'center', inline: 'nearest'});
      }
    }
  },
  paginationLetterClick(parameter: string) {
    this.active = parameter;
    const url = window.location.origin + window.location.pathname + '#' + parameter;
    history.replaceState(null, '', url);
    const glossaryContainerElement = document.getElementById('glossary-container');
    if (glossaryContainerElement) {
      glossaryContainerElement.scrollIntoView();
    }
  }
});
